import {AppBar, IconButton, ListItemIcon, ListItemText, Menu, MenuItem, Toolbar} from "@mui/material";
import {DarkMode, Home, LightMode, Menu as MenuIcon} from "@mui/icons-material";
import Typography from "@mui/material/Typography";
import {useState} from "react";
import {useNavigate} from "react-router";
import route from "../../../enum/route";
import isNull from "../../../mixin/isNull";
import database from "../../../database/database";
import useEventDispatcher from "../../../use/useEventDispatcher";

export default function () {
    const eventDispatcher = useEventDispatcher();
    const navigate = useNavigate();
    const [anchorEl, setAnchorEl] = useState(null);

    const handleMenu = (event) => setAnchorEl(event.currentTarget);
    const handleClose = () => setAnchorEl(null);

    const handleHome = () => {
        navigate(route.ENTREPRENEUR_SUGGESTIONS);
        handleClose();
    }

    const handleTheme = theme => () => {
        eventDispatcher.launcher("toggle-mode", {
            mode: theme
        });
        handleClose();
    }


    return (
        <AppBar position="sticky" sx={{top: 0}}>
            <Toolbar>
                <Typography variant="h6" component="div" sx={{flexGrow: 1, textTransform: "uppercase"}}>
                    Nouvelle intervention
                </Typography>
                <div>
                    <IconButton
                        size="large"
                        aria-label="account of current user"
                        aria-controls="menu-appbar"
                        aria-haspopup="true"
                        onClick={handleMenu}
                        color="inherit"
                    >
                        <MenuIcon/>
                    </IconButton>
                    <Menu
                        id="menu-appbar"
                        anchorEl={anchorEl}
                        anchorOrigin={{
                            vertical: 'top',
                            horizontal: 'right',
                        }}
                        keepMounted
                        transformOrigin={{
                            vertical: 'top',
                            horizontal: 'right',
                        }}
                        open={Boolean(anchorEl)}
                        onClose={handleClose}
                    >
                        {
                            !isNull(database.read(database.TABLE_THEME, "dark"))
                            && database.read(database.TABLE_THEME, "dark") === "dark"
                                ? <MenuItem onClick={handleTheme("light")}>
                                    <ListItemIcon>
                                        <LightMode/>
                                    </ListItemIcon>
                                    <ListItemText>
                                        Theme blanc
                                    </ListItemText>
                                </MenuItem>
                                : <MenuItem onClick={handleTheme("dark")}>
                                    <ListItemIcon>
                                        <DarkMode/>
                                    </ListItemIcon>
                                    <ListItemText>
                                        Theme sombre
                                    </ListItemText>
                                </MenuItem>
                        }
                        <MenuItem onClick={handleHome}>
                            <ListItemIcon>
                                <Home/>
                            </ListItemIcon>
                            <ListItemText>
                                Revenir à l'accueil
                            </ListItemText>
                        </MenuItem>
                    </Menu>
                </div>
            </Toolbar>
        </AppBar>
    );
}